<div class="provider-details">
  <div class="modules">
    <section class="detail-tabs-header" data-test="tabs-header">
      <ng-container *ngFor="let module of moduleNames">
        <button
          [ngClass]="{'selected-section' : module === lastSelectedSection}"
          class="detail-section-link"
          (click)="scrollToSection(module)"
          [attr.data-test]="'section-link-' + module"
        >
          {{module}}
        </button>
      </ng-container>
    </section>
  
    <section
      *ngIf="providerBio?.length"
      id="about-section"
      class="about info-module"
      data-test="about-section"
    >
      <a id="about-link" [href]="currentRoute + '#about'">
        <h2>Meet {{providerShareableProfile.display_first_name}}</h2>
      </a>
      <p data-test="provider-bio">{{providerBio}}</p>

      <div class="clients-are-saying" data-test="clients-are-saying" *ngIf="this.showTestimonial">
        <div class="icon-header">
          <iris-icon
            name="quote"
            [size]="iconSizes.LG"
            colorToken="$color-dec-indigo-100"
          />
          <h2>Clients are saying...</h2>
        </div>
        <div class="testimonial">
          <span class="testimonial-feedback">{{this.latestTestimonialFeedback}}</span>
          <span class="testimonial-source">{{this.latestTestimonialSource}}</span>
        </div>
      </div>
    </section>

    <section 
      *ngIf="providerShareableProfile?.specialties?.length > 0" 
      class="specialties info-module"
      id="specialties-section"
      data-test="specialties-section"
    >
      <section data-test="specialties">
        <hr />
        <a id="specialties-link" [href]="currentRoute + '#specialties'" class="section-header">
          <iris-icon
            name="stars"
            [size]="iconSizes.MD"
            colorToken="$color-dec-kelly-100"
          />
          <h2>{{headerNames.SPECIALIZES_IN}}</h2>
        </a>
        <div 
          class="top-specialties-pills" 
          data-test="top-specialties-pills"
        >
          <pill *ngFor="let speciality of topSpecialties"
            icon="star"
            [displayText]="speciality.name"
          />  
        </div>
        <div class="parallel-list-container">
          <div class="single-column-list">
            <h3 *ngIf="allOtherSortedSpecialties.length">
              General expertise in
            </h3>
            <ul data-test="specialties-section-list">
              <li *ngFor="let specialty of allOtherSortedSpecialties">
                {{ specialty }}
              </li>
            </ul>
          </div>
          <div class="single-column-list" *ngIf="treatmentApproaches.length">
            <h3>Treatment approaches</h3>
            <ul>
              <li *ngFor="let approach of treatmentApproaches">{{approach}}</li>
            </ul>
          </div>
        </div>
      </section>
    </section>
    <section
      class="info-module"
      id="works-with-section"
      data-test="works-with-section"
    >
    <hr />
      <a id="works-with-link" [href]="currentRoute + '#workswith'" class="section-header">
        <iris-icon
          name="groups"
          [usage]="iconUsageTypes.DECORATIVE"
          [size]="iconSizes.LG"
          colorToken="$color-dec-kelly-100"></iris-icon>
        <h2> 
          {{moduleNames[moduleNames.length - 2]}}
        </h2>
      </a>
      <div class="parallel-list-container">
        <div class="single-column-list">
          <h3>Types of services</h3>
          <ul>
            <li *ngFor="let serviceOffered of providerShareableProfile.services_offered">{{serviceOffered?.name}}</li>
          </ul>
        </div>
        <div class="single-column-list" *ngIf="agesSupported.length > 0">
          <h3>Ages</h3>
          <ul>
            <li *ngFor="let age of agesSupported">{{age}}</li>
          </ul>
        </div>
      </div>

      <div class="parallel-list-container">
        <div class="single-column-list" *ngIf="communitiesSupported.length > 0">
          <h3>Communities supported</h3>
          <ul>
            <li *ngFor="let community of communitiesSupported">{{community}}</li>
          </ul>
        </div>
        <div class="single-column-list">
          <h3>Languages</h3>
          <ul>
            <li *ngFor="let language of providerShareableProfile.languages">{{language?.name}}</li>
          </ul>
        </div>
      </div>
    </section>

    <section
      id="insurance-and-licensure-section"
      class="info-module insurance-and-licensure"
      data-test="insurance-and-licensure-section"
    >
      <hr />
      <a id="insurance-and-licensure-link" [href]="currentRoute + '#insurance-and-licensure'" class="section-header">
        <iris-icon
          name="verified_user"
          [size]="iconSizes.MD"
          colorToken="$color-dec-kelly-100"
        />
        <h2>{{moduleNames[moduleNames.length - 1]}}</h2>
      </a>
      
      <ng-container *ngIf="providerNetworkCompaniesGroupedByInsuranceName.length > 0">
        <h3>Insurance accepted</h3> 
        <div
          *ngFor="let insuranceGroup of providerNetworkCompaniesGroupedByInsuranceName"
          class="insurance-list"
          data-test="insurances-section-list"
        >
          <span class="insurance-group-name"> {{ insuranceGroup[0].insurance_name }} </span>
          <ul *ngIf="insuranceGroup.length > 1">
            <li *ngFor="let pnc of insuranceGroup">
              {{ pnc.name }}
            </li>
          </ul>
        </div>
      </ng-container>

      <ng-container *ngIf="licensures.length > 0">
        <h3>Licensure</h3>
        <ul data-test="licensure-section-list">
          <li *ngFor="let licensure of licensures">
            {{ licensure }}
          </li>
        </ul>
      </ng-container>
      
      <ng-container *ngIf="stateLicenses.length > 0">
        <h3>Licensed in</h3>
        <ul data-test="licensed-in-list">
          <li *ngFor="let stateLicense of stateLicenses">
            {{ stateLicense }}
          </li>
        </ul>
      </ng-container>
    </section>
  </div>
</div>